import React from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";
import TextAmount from 'components/text/TextAmount';


const PrincipalList = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }
  let principals = data.principals;
  return (
    <div className="calc-setting-table">
    <table className="table">
      <colgroup>
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
      <tr>
        <th colSpan="5" className="text-left calc-setting-table-header">Höfuðstólar</th>
      </tr>
      <tr>
        <th className="text-right">Gjalddagi</th>
        <th className="text-right">Drv.dagur</th>
        <th className="text-right">Útgefið</th>
        <th className="text-right">Reikna drv.</th>
        <th className="text-right">Upphæð</th>
      </tr>
      </thead>
      <tbody>
      {principals.map(function(item,i){
        return(
          <tr key={i}>
            <td className="text-right"><TextDate value={item.dueDate}/></td>
            <td className="text-right"><TextDate value={item.finalDueDate}/></td>
            <td className="text-right"><TextDate value={item.issueDate}/></td>
            <td className="text-right"><TextBoolean value={item.calculatePenaltyInterest}/></td>
            <td className="text-right"><TextAmount value={item.amount}/></td>
          </tr>);
      })}
      </tbody>
    </table>
  </div>
  );
};

PrincipalList.propTypes = {
  data: PropTypes.object,
};

export default PrincipalList;
